import styled from 'styled-components';
import { colors } from '../colors';

interface badgeProps {
	margin?: string;
	docBadge?: boolean;
	fileBadge?: boolean;
	tradeBadge?: boolean;
}

const Badge = styled.span<badgeProps>`
	color: ${colors.Black};
	height: 30px;
	width: auto;
	font-size: 12px;
	line-height: 14px;
	padding: 5px 12px;
	border-radius: 50px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: ${colors.GreyF6};
	margin: ${({ margin }) => margin};
	${({ docBadge }) =>
		docBadge &&
		`img{
			margin-right:6px;
		}
	`}
	${({ fileBadge }) =>
		fileBadge &&
		`border-radius: 4px;
		background-color: ${colors.BlueDE};
		color: ${colors.Blue25};
		height:auto;
		padding: 4px 6px 2px;
		font-size: 10px;
		text-transform: uppercase;
		font-family: 'RubikMedium';
		margin:-1px 0 0 8px;
		float: right;
	`}
	${({ tradeBadge }) =>
		tradeBadge &&
		`border-radius: 4px;
		background-color: ${colors.White};
		color: ${colors.GreyA0};
		height:auto;
		padding: 0;
		font-size: 13px;
		margin:2px 0 0 0;
		float: right;
	`}
`;

export default Badge;
